/**
 * A function that takes an input value and returns a formatted string.
 */
export type Formatter<T> = (value: T) => string;
